import axiosInstance, { API_ROUTES } from '@/lib/http/httpRequest';
import { AxiosResponse } from 'axios';
import {
    BOARD,
    IMAGE_TEMPLATES,
    LeaderboardPeriod,
    LeaderBoardTotalScores,
    LeadersRank,
    MemberRank,
    ShareLeaderboardResponse,
} from '@/state/leaderboard/leaderboardTypes';

interface LeaderboardPayload {
    board: BOARD;
    from?: number;
    to?: number;
    period: LeaderboardPeriod;
}

interface GetRankingsPayload extends Omit<LeaderboardPayload, 'to'> {
    to: number;
}

export const getAllMyRanks = (params: {
    period: LeaderboardPeriod;
}): Promise<AxiosResponse<MemberRank[]>> =>
    axiosInstance.get(`${API_ROUTES.LEADERBOARD}/my-positions`, { params });

export const getTotalScores = (params: {
    period: LeaderboardPeriod;
}): Promise<AxiosResponse<LeaderBoardTotalScores>> =>
    axiosInstance.get(`${API_ROUTES.LEADERBOARD}/total-scores`, { params });

export const getRankings = (params: GetRankingsPayload): Promise<AxiosResponse<LeadersRank[]>> =>
    axiosInstance.get(`${API_ROUTES.LEADERBOARD}/positions`, { params });

export const getSurroundingRanks = (
    rankId: number,
    num: number,
    board: BOARD,
    period: LeaderboardPeriod,
) =>
    axiosInstance.get(`${API_ROUTES.LEADERBOARD}/positions/${rankId}/surrounding`, {
        params: { num, board, period },
    });

export const getLeaderboardSettings = () => axiosInstance.get(`${API_ROUTES.LEADERBOARD}/settings`);
export const updateExistingLeaderboardSettings = (data: any) =>
    axiosInstance.post(`${API_ROUTES.LEADERBOARD}/settings`, data);

export const setLeaderboardSettings = (data: any) =>
    axiosInstance.patch(`${API_ROUTES.LEADERBOARD}/settings`, data);

export const shareLeaderboard = (data: {
    layout: IMAGE_TEMPLATES;
    period: LeaderboardPeriod;
}): Promise<AxiosResponse<ShareLeaderboardResponse>> =>
    axiosInstance.post(`${API_ROUTES.LEADERBOARD}/share`, data);
